import CrmClient from './CrmClient';

export default class CrmOrder {
    id: number | null;
    uuid: string | null;
    client: CrmClient | null;
    comment: string;
    delivery: object | null;
    expenses_sum: number;
    external_order_number: string;
    integration_order: object | null;
    payment_method: string;
    source: object | null;
    status: object | null;
    sum: number;
    created_at: string | null;
    updated_at: string | null;

    constructor(data: any) {
        this.id = data?.id ?? null;
        this.uuid = data?.uuid ?? null;
        this.client = data?.client ? new CrmClient(data.client) : null;
        this.comment = data?.comment ?? '';
        this.delivery = data?.delivery ?? null;
        this.expenses_sum = data?.expenses_sum ?? 0;
        this.external_order_number = data?.external_order_number ?? '';
        this.integration_order = data?.integration_order ?? null;
        this.payment_method = data?.payment_method ?? '';
        this.source = data?.source ?? null;
        this.status = data?.status ?? null;
        this.sum = data?.sum ?? 0;
        this.created_at = data?.created_at ?? null;
        this.updated_at = data?.updated_at ?? null;
    }
}